import { defineNuxtPlugin, addRouteMiddleware } from "nuxt/app";
import Auth from "../utils/auth";
import authGlobalMiddleware from "../middleware/auth.global";

export default defineNuxtPlugin({
  name: "ckweb:auth",
  dependsOn: ["ckweb:settings", "ckweb:dev-console"],
  async setup() {
    addRouteMiddleware("auth.global", authGlobalMiddleware, { global: true });

    const config = useRuntimeConfig();

    const auth = new Auth(config);

    devConsole.info("🛠️ ckAuth: $auth created 🚀🚀🚀🚀🚀");

    return {
      provide: {
        auth,
      },
    };
  },
});
